import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { PageSection } from '../../../Layout';
import ids from '../../QestIds';
import { MeasurementsSection, ResultsSection } from '../Sections';
import { AstmDryMassesSection, AstmPreparationSection, AstmReportSection } from './Sections';

const qestIds = [ids.moistureContent.ASTM_D_2216.rev2019];

const AstmMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <PageSection heading="Preparation">
      <AstmPreparationSection />
    </PageSection>

    <PageSection heading="Measurements">
      <MeasurementsSection />
    </PageSection>

    <PageSection>
      <WorksheetTestedBySection />
    </PageSection>

    <PageSection heading="Dry Mass">
      <AstmDryMassesSection />
    </PageSection>

    <WorksheetResultsSection heading="Results">
      <ResultsSection />
      <AstmReportSection />
    </WorksheetResultsSection>

    <PageSection heading="Images and Remarks">
      <WorksheetImagesAndRemarksSection />
    </PageSection>
  </>
);

AstmMoistureContentWorksheet.qestIds = qestIds;

export default AstmMoistureContentWorksheet;
export { AstmMoistureContentWorksheet };
